import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import { get } from "lodash";
import success from "../../../src/waitlistDocVault/assets/images/success.png";
import failure from "../../../src/waitlistDocVault/assets/images/failure.png";
import { toast, ToastContainer } from "react-toastify";
import { useHistory } from "react-router-dom";
import { dpValidation, getThirdPartyData, setConsentApi, updateThirdPartyData } from "../../waitlist/services/waitlist-service";
import { setAnalyticsEvent } from "../../core/helpers/analytics";
// import ReactPixel from 'react-facebook-pixel';
import { utils } from "../../core/helpers/utils";

export default function KycDematContentNew(props) {
  const [isDemat, setIsDemat] = useState(false);
  const [show, setShow] = useState(false);
  const [dematNum, setDematNum] = useState("");
  const [dematNum2, setDematNum2] = useState("");
  const [pan, setPan] = useState(props.panValue);
  const [isMobile, setIsMobile] = useState(false);
  const [dematPresent, setDematPresent] = useState(false);
  const [tmpDemat, setTmpDemat] = useState('');
  const [tmpDemat2, setTmpDemat2] = useState('');
  const [validityLabel, setValidityLabel] = useState('');
  const [dematTrue, setDematTrue] = useState('');
  const history = useHistory();
  const [inputType, setInputType] = useState('password');
  const [checked, setChecked] = React.useState(true);
  const [product, setProduct] = useState(props?.product);


  function toggle() {
    setShow(!show);
    props.moveNextTab();
  }

const setConsent = () => {
    let headers = {
      "X-product": `orobonds:default`,
    };
    let payload = utils.encryptedPayload({
      type: "demat",
      consent: checked,
    });
    setConsentApi(payload, headers)
      .then((result) => {
        const response = utils.parsePayload(result);
        if (!response) {
          return toast.error("setConsent: something went wrong!");
        }
        if (response && !response.successs) {
          return toast.error(response.message || "Consent not recorded")
        }
      });
  };

  const getRecentPan = () => {
    let data;
    let tmpPan;

    getThirdPartyData({"X-product": `orobonds:default`, 'x-encrypted-data': true})
        .then((result) => {
        const response = utils.parsePayload(result);
        if (response && response.success && response.data) {
          data = response.data;
          tmpPan = data && data.pan ? data.pan : "";
          let getDemat = get(response, 'data.demat', '');
          setPan(tmpPan.toUpperCase());
          setDematNum(getDemat);
          setTmpDemat(getDemat.replace(/[^\dA-Z]/g, '').replace(/(.{8})/g, '$1 ').trim());
          if (getDemat){
            setDematPresent(true);
          }
        }
      });
  };

  useEffect(() => {
    // ReactPixel.init('1613991859107974');
    let mobile = window.matchMedia("(max-width: 768px").matches;
    setIsMobile(mobile);
    getRecentPan();
  }, []);

  useEffect(() => {
    setPan(props.panValue);
  }, [props.panValue]);

  const setDematValue = (val) => {
    setTmpDemat(val.replace(/[^\dA-Za-z0-9]/g, '').replace(/(.{8})/g, '$1 ').trim());
    const result = val.replace(/[^0-9a-zA-Z]/g, '');
    setDematNum(result);
  };

  const setDematValue2 = (val) => {
    setTmpDemat2(val.replace(/[^\dA-Za-z0-9]/g, '').replace(/(.{8})/g, '$1 ').trim());
    const result = val.replace(/[^0-9a-zA-Z]/g, '');
    setDematNum2(result);
  };


  const thirdPartyData = () => {    
    if (dematNum.length === 16) {
      if (dematNum === props.userProfile.demat &&
        (props.errors && props.errors.length)) {
            toast.error('Please enter a new demat number to verify.');
            return;
          }
      if (dematNum !== dematNum2){
        setDematTrue("invalid");
        return setValidityLabel("DP ID confirmation does not match!");
      }
      let dpId = dematNum.substr(0, 8);
      dpValidation(dpId, {"X-product": `orobonds:default`}).then(
        (result) => {
          const dpResp = utils.parsePayload(result);
          if (dpResp && dpResp.success) {
            setAnalyticsEvent("Bonds_KYC_Demat_Verfied");
            var msg = dpResp.message + " - " + (dpResp.data && dpResp.data.length && dpResp.data[0].dpName);
            setValidityLabel(msg);
            setIsDemat(true);
            const payload = utils.encryptedPayload({
              pan: pan ?? '',
              demat: dematNum,
              dpName: dpResp.data && dpResp.data.length && dpResp.data[0].dpName,
              productName: 'oroBonds',
            });

            updateThirdPartyData(payload, {"X-product": `orobonds:default`, 'x-encrypted-data': true })
              .then((resp) => {
                if (!resp || !resp.success) {
                  toast.error(resp.msg || "something went wrong: thirdParty");
                } else {
                  setIsDemat(true);
                  setDematTrue("valid");
                  setConsent();
                  props.setReupload(true);
                  setAnalyticsEvent("SIkycDematverified");
                  // ReactPixel.track('APPLICATION FILLED (KYC)');
                  setTimeout(() => {
                    setShow(true);
                  }, 1500);                  
                }
              });
          } else {
            setValidityLabel(dpResp.message);
            setDematTrue("invalid");
          }
        }
      );
    } else {
      setValidityLabel("Please enter Demat");
      setDematTrue("invalid");
    }   
  };

  useEffect(() => {
    if (props.from && props.from === "investmentOverview" && show) {
      setTimeout(() => {
        setShow(false);
        history.push({
          pathname: `/biddeasy-asset/${product}`,
          state: {  
            from: "dematCheck",
            isDematVerified: true
          }
        });
      }, 2000);      
    } else if(show) {
      props.updateDocStatus();
      setTimeout(() => {
        props.moveNextTab();
      }, 2500);
    }
  }, [show]);

  return (
    <>
      <div className="kyc-content-block">
        <Container className="form-container justify-content-center">
          <Row>
            <Col>
              <div
                className={!isMobile ? "adress-banner border" : "adress-banner-mob border"}
              >
                <div>
                  <Form>
                    {!props?.isKycDone ? (
                      <h5 style={{ color: "black" }} className="mt-3">
                        <strong className="text-capitalize">Verify your DEMAT account</strong>
                      </h5>
                    ) : null}

                    <>
                        <div className="d-flex mb-2 justify-content-between">
                          <Input
                            type={inputType}
                            placeholder="Enter DEMAT account number*"
                            name={"Demat No."}
                            maxLength={17}
                            value={tmpDemat}
                            onBlur={() => setInputType('password')}
                            onFocus={() => setInputType('text')}
                            className="mt-4 mb-2"
                            onChange={(e) => setDematValue(e.target.value)}
                          ></Input>
                        </div>
                        {validityLabel && 
                          <div className="validity-label d-flex">
                            <label
                              className={dematTrue}
                            >{validityLabel}
                            </label>
                          </div>
                        }
                        <Input
                            type="text"
                            placeholder="Confirm DEMAT account number*"
                            name={"Demat No."}
                            maxLength={17}
                            value={tmpDemat2}
                            className="mt-4 mb-2"
                            onChange={(e) => setDematValue2(e.target.value)}
                          ></Input>
                        
                        <div className="consent d-flex mt-4">
                          <div>
                            <input
                              style={{'accentColor': '#283A97'}}
                              type="checkbox"
                              defaultChecked={checked}
                              onChange={() => setChecked(!checked)}
                            />
                          </div>
                          <div>
                            <p className="font-size-8 ml-2">
                              I confirm that the above mentioned Demat ID belongs to me, and on successful 
                              completion of the transaction, the bond units purchased will be transferred to 
                              the above mentioned Demat ID.
                            </p>
                          </div>
                        </div>
                    </>

                        <Button
                          color="#22c979"
                          className="mt-3"
                          disabled={!checked}
                          onClick={thirdPartyData}
                        >
                          Link your DEMAT
                        </Button>

                        <h6
                          className="mt-4 demat-link"
                          onClick={()=> window.open("https://marketing.biddeasy.com/Assets/webAssets/ICM_DEMAT.pdf", "_blank")}
                        >
                          How do I find my DEMAT number?
                        </h6>
                  </Form>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        <ToastContainer />
      </div>
      {show && (
        <Modal centered isOpen={show} toggle={toggle}>
          <ModalHeader className="close-button p-0">
            <span onClick={toggle}>x</span>
          </ModalHeader>
          <ModalBody style={{marginTop: '-20px'}}>
            {isDemat ? (
              <div>
                <div className="pt-1">
                  <img
                    style={{
                      display: "block",
                      marginLeft: "auto",
                      marginRight: "auto",
                    }}
                    src={success}
                    alt="success-icon"
                  ></img>
                </div>
                <p className="text-center mt-4 font-size-20 font-weight-semi-bold">
                  Your Demat details are linked successfully!
                </p>
              </div>
            ) : (
              <div>
                <div className="pt-1">
                  <img
                    style={{
                      display: "block",
                      marginLeft: "auto",
                      marginRight: "auto",
                    }}
                    src={failure}
                    alt="failure-icon"
                  ></img>
                </div>
                <p
                  className="text-center mt-4 font-weight-semi-bold font-size-20"
                >
                  Your Demat details are not uploaded
                </p>
              </div>
            )}
          </ModalBody>
        </Modal>
      )}
      <ToastContainer />
    </>
  );
}
